import type { StoreApi } from 'zustand';
import type { ProductPageProps } from '@product/ProductPage/ProductPage';
import type { ProductPageStore } from './useProductPageStore';
import type { UnitSystem } from '@icommerce/units';
import { getUnitCodeForUnitSystem, getUnitLabel } from '@icommerce/units';
import { getLengthUnitCodeByPriceType, getProductPriceType } from '@libs/product.helper';

export interface PieceAndLengthConfiguration {
  pieces: number;
  length: number;
}
export interface ProductConfigSlice extends PieceAndLengthConfiguration {
  unitSystem: UnitSystem;
  unitLabel: string;
  setPiecesAndLength: (data: PieceAndLengthConfiguration) => void;
}

export const createProductConfigSlice = (
  set: StoreApi<ProductPageStore>['setState'],
  initialData: ProductPageProps
) => {
  const priceType = getProductPriceType(initialData.currentProduct);

  const metricLengthUnitCode = getLengthUnitCodeByPriceType(priceType, initialData.unitSystem);
  const lengthUnitCodeForUnitSystem =
    metricLengthUnitCode && getUnitCodeForUnitSystem(metricLengthUnitCode, initialData.unitSystem);

  const unitLabel = getUnitLabel(lengthUnitCodeForUnitSystem);

  return {
    unitSystem: initialData.unitSystem,
    unitLabel,
    setPiecesAndLength: data => {
      set(state => ({
        ...state,
        pieces: data.pieces,
        length: data.length,
      }));
    },
  } as ProductConfigSlice;
};
